import React from "react";

function ClientPhone ({ clientInfo }) {

    const isNonResident = clientInfo.passport && !clientInfo.identity

    return (
        <span style={{ marginLeft: '1rem' }}>
            <strong>טלפון:</strong>  {clientInfo['phone'] ? `${isNonResident ? '' : '0'}${clientInfo['phone']}` : '-'}
        </span>
    )
}

export default ClientPhone